export const state = () => ({
  menuFilterList: [],
  restrictionIntervalList: null,
  menuGuidFilter: null,
  sectionGuidFilter: '',
  saleRateFilter: null,
  dateRangeFilter: null,
  undoBuffer: [],
  undoBufferLength: 3
});
